// extracted by mini-css-extract-plugin
export default {"heading":"PreTitle_heading__gkP0n"};